import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UserApiService } from '@projects/admin/src/app/services/user-api.service';
import { UserService } from '@projects/admin/src/app/services/user.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-clone-user-modal',
  templateUrl: './clone-user-modal.component.html',
  styleUrl: './clone-user-modal.component.scss',
})
export class CloneUserModalComponent implements OnInit, OnDestroy {
  constructor(
    public userService: UserService,
    private userApiService: UserApiService,
    private fb: FormBuilder
  ) { }
  userCloneForm = this.fb.group({
    FirstName: ['', Validators.required],
    LastName: ['', Validators.required],
    IbexId: [''],
    Password: [''],
    Email: ['', [Validators.required, Validators.email]],
    Username: ['', [Validators.required, Validators.email]],
    PseudoName: ['', [Validators.required]],
    PhoneNumber: ['', [Validators.pattern(/^\+[0-9]{11,12}$/)]],
  });

  ngOnInit(): void {
    this.userService.userCloneModal.$selectUser.subscribe(
      (selectUser) => {
        if (selectUser) {
          const requiredFields = ['IbexId'];
          if (!this.userService.userCloneModal.inputData.isAgent) {
            this.userCloneForm.get('IbexId')?.disable();
            // this.userCloneForm.get('Password')?.disable();
            requiredFields.forEach(field => {
              const control = this.userCloneForm.get(field);
              if (control) {
                control.setValidators(null);
                control.updateValueAndValidity();
              }
            });
          } else {
            this.userCloneForm.get('IbexId')?.enable();
            // this.userCloneForm.get('Password')?.enable();
            requiredFields.forEach(field => {
              const control = this.userCloneForm.get(field);
              if (control) {
                const validators: any[] = [Validators.required];
                if (field === 'IbexId') validators.push(Validators.pattern('^[a-zA-Z0-9]{3,5}$'));
                control.setValidators(validators);
                control.updateValueAndValidity();
              }
            });
          }
        }
      });

    this.setupAutoFillForNewUser();
  }

  ngOnDestroy(): void { }

  public checkUserFormFieldValidation(fieldName: string): boolean {
    const control = this.userCloneForm.get(fieldName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  public closeModal(): void {
    this.userCloneForm.reset({
      FirstName: '',
      LastName: '',
      Email: '',
      Username: '',
      PseudoName: '',
      IbexId: '',
      Password: '',
    });
    this.userCloneForm.markAsPristine();
    this.userCloneForm.markAsUntouched();
    this.userService.userCloneModal.$selectUser.next(false);
    this.userService.userCloneModal.isModalOpen = false;
  }
 
  public cloneUser() {
    if (this.userCloneForm.valid) {
      const { Username, IbexId } = this.userCloneForm.value;

      const usernameCheck$ = this.userApiService.checkUserNameExists({ username: Username || '' });
      const ibexIdCheck$ = this.userApiService.checkUserNameExists({ ibexId: IbexId || '' });

      forkJoin([usernameCheck$, ibexIdCheck$]).subscribe({
        next: ([usernameRes, ibexIdRes]: any) => {
          if ((usernameRes && Object.keys(usernameRes).length) && (ibexIdRes && Object.keys(ibexIdRes).length)) {
            this.userService.toastService.error('Username & Ibex ID already exists');
            return;
          }
          if (usernameRes && Object.keys(usernameRes).length) {
            this.userService.toastService.error('Username already exists');
            return;
          }
          if (ibexIdRes && Object.keys(ibexIdRes).length) {
            this.userService.toastService.error('Ibex ID already exists');
            return;
          }
          const payload = {
            CloneUserId: this.userService.userCloneModal.inputData.cloneId,
            CreatedBy: this.userService.userCloneModal.inputData.createdBy,
            ...this.userCloneForm.value
          };
          this.userApiService.userClone(payload).subscribe({
            next: (res: any) => {
              this.closeModal();
              this.userService.isUserListUpdated.next({ isUpdated: true });
              this.userService.toastService.success('User Cloned Successfully');
            },
            error: (err) => {
              console.error('Check failed', err);
              this.userService.toastService.error('Something went wrong while cloning user');
            }
          })
        },
        error: (err) => {
          console.error('Check failed', err);
          this.userService.toastService.error('Something went wrong while checking username or Ibex ID');
        }
      });
    } else {
      this.userCloneForm.markAllAsTouched();
    }
  }
  public getFieldError(fieldName: string): string | null {
    return this.userService.getFieldError(fieldName, this.userCloneForm);
  }
  private setupAutoFillForNewUser(): void {
  const form = this.userCloneForm;

  const firstNameControl = form.get('FirstName');
  const lastNameControl = form.get('LastName');

  if (!firstNameControl || !lastNameControl) return;

  firstNameControl.valueChanges.subscribe(() => this.autoFillUserFields()),
  lastNameControl.valueChanges.subscribe(() => this.autoFillUserFields())
}

  private autoFillUserFields(): void {
    const form = this.userCloneForm;

    const firstName: any = form.get('FirstName')?.value?.trim();
    const lastName: any = form.get('LastName')?.value?.trim();

    if (!firstName || !lastName) return;

    const emailValue = `${firstName}.${lastName}@flecx.io`;
    const pseudoValue = `${firstName} ${lastName}`;

    if (!form.get('Email')?.dirty) {
      form.get('Email')?.setValue(emailValue, { emitEvent: false });
    }

    if (!form.get('Username')?.dirty) {
      form.get('Username')?.setValue(emailValue, { emitEvent: false });
    }

    if (!form.get('PseudoName')?.dirty) {
      form.get('PseudoName')?.setValue(pseudoValue, { emitEvent: false });
    }
  }
}
